import { render, staticRenderFns } from "./PastProjectCreateView.vue?vue&type=template&id=0f72d81b&"
import script from "./PastProjectCreateView.vue?vue&type=script&lang=ts&"
export * from "./PastProjectCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports